export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-bitcoin-421934c9c8117c023837c9c94c494fdc.svg";